import { combineReducers } from 'redux'
import commonDucks from './commonDucks'
import commonLogDucks from './commonLogDucks'
import settingDucks from './settingDucks'
import userDucks from './userDucks'
import notificationDucks from './notificationDucks'

import chiNhanhDucks from './chiNhanhDucks'
import duAnDucks from './duAnDucks'
import heThongDucks from './heThongDucks'

import customerDucks from './customerDucks'
import categoryDucks from './categoryDucks'
import productDucks from './productDucks'
import orderDucks from './orderDucks'
import invoiceDucks from './invoiceDucks'
import menuDucks from './menuDucks'
import reportDucks from './reportDucks'





const rootReducer = combineReducers({
  common: commonDucks,
  commonLog: commonLogDucks,
  setting: settingDucks,
  user: userDucks,
  notification: notificationDucks,
  chiNhanh: chiNhanhDucks,
  duAn: duAnDucks,
  heThong: heThongDucks,
  customer: customerDucks,
  category: categoryDucks,
  product: productDucks,
  order: orderDucks,
  invoice: invoiceDucks,
  menu: menuDucks,
  report: reportDucks,
})

export default rootReducer
